import { createContext } from 'react';

import type { NEditSalesFunnelProvider } from '@app/providers/EditSalesFunnelProvider/EditSalesFunnelProvider.types';

export const EditSalesFunnelContext =
  createContext<NEditSalesFunnelProvider.Context>({
    currentSalesFunnelStages: [],
    isSalesFunnelStagesLoading: false,
    salesFunnelId: null,
    refetchGetSalesFunnelStages: () => {},
    salesFunnelStagesError: undefined,
  });
